import { render } from "./SaleItems.vue?vue&type=template&id=bfd11a50&scoped=true"
import script from "./SaleItems.vue?vue&type=script&lang=js"
export * from "./SaleItems.vue?vue&type=script&lang=js"

import "./SaleItems.vue?vue&type=style&index=0&id=bfd11a50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd11a50"]])

export default __exports__